import {useApolloClient, ApolloClient} from "@apollo/client";
import {HookClass} from "@dvrt/graphql-widgets";
import {DomainBulkCapabilityDocument} from "../queries.generated";
import {useEffect, useState} from "react";
import {Auth, useAuth} from "@/context/AuthProvider";
import {DomainNameDocument, DomainNameQuery, DomainNameQueryVariables} from "@/queries.generated";
import {DomainBulkCapabilityQuery, DomainBulkCapabilityQueryVariables} from "../queries.generated";
import {CapabilityModificationType} from "@/api";
import {BulkCapabilityModificationInfo} from "@/api";

export type BulkCapabilityFormValues = {
    values: BulkCapabilityFormValue[];
};

// Extend the query type with the modification type
export type BulkCapabilityFormValue = {
    changeType: CapabilityModificationType;
} & BulkCapabilityModificationInfo;

export default class DataSource extends HookClass {
    protected domainId: number;
    domainName: string;
    protected client: ApolloClient<object>;
    data: BulkCapabilityModificationInfo[];
    private setData: (v: BulkCapabilityModificationInfo[]) => void;
    private setDomainName: (v: string) => void;
    auth: Auth;

    useHooks(domainId: number) {
        this.domainId = domainId;
        this.client = useApolloClient();
        this.auth = useAuth();
        [this.data, this.setData] = useState();
        [this.domainName, this.setDomainName] = useState();
        useEffect(() => {
            this.fetch();
        }, []);
    }

    async fetch() {
        const result = await this.client.query<DomainBulkCapabilityQuery, DomainBulkCapabilityQueryVariables>({
            query: DomainBulkCapabilityDocument,
            variables: {
                domainId: this.domainId,
            },
            fetchPolicy: "no-cache",
        });

        const domainName = await this.client.query<DomainNameQuery, DomainNameQueryVariables>({
            query: DomainNameDocument,
            variables: {
                id: this.domainId,
            },
            fetchPolicy: "no-cache",
        });

        const data = result.data.domainBulkCapability;

        this.setData(data);
        this.setDomainName(domainName.data.domains.items[0].name);
    }

    get loaded() {
        return !!this.data;
    }

    get initialData(): BulkCapabilityFormValues {
        if (this.data)
            return {
                values: this.data.map((cap) => ({
                    ...cap,
                    changeType: CapabilityModificationType.Keep,
                })),
            };
        else return {values: []};
    }
}
